var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1576 18.8422L13.7655 17.2343L13.7654 17.2342L20.1969 10.8028L18.589 9.19487L13.2374 14.5465V2.23438H10.9635V14.4323L5.72605 9.19487L4.11816 10.8027L10.5496 17.2342L10.5496 17.2343L12.1574 18.8422L12.1575 18.8421L12.1576 18.8422ZM7.99987 23.9998H15.9999V21.9998H7.99987V23.9998Z",
    fill: "#212624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownload);
export default __webpack_public_path__ + "static/media/icon_arrow_download.dbec641799bb1037998a7ae8d95d9a58.svg";
export { ForwardRef as ReactComponent };